import { cx } from "@emotion/css";

import { useTheme } from "@/modules/theme/hooks/useTheme";
import { useUserDataContext } from "@/modules/user/hooks/useUserDataContext";

import { FirstLoadingLevelsView } from "../FirstLoadingLevelsView";

import { createRankingStyles } from "./createRankingStyles";
import { useGetRankingQuery } from "./useGetRankingQuery";

export type Person = {
  id: string;
  name: string;
  points: number;
};

export const Ranking = () => {
  const classes = createRankingStyles(useTheme());

  const currentUser = useUserDataContext();
  const {
    data: rankingList,
    isLoading: isRankingLoading,
  } = useGetRankingQuery();

  if (isRankingLoading) {
    return <FirstLoadingLevelsView />;
  }

  return (
    <ul className={classes.root}>
      {rankingList?.map(({ place, name, points, id }) => (
        <li
          className={cx(
            classes.user,
            currentUser.userDetails?.id === id && classes.currentUser
          )}
          key={id}
        >
          <div data-place={place} className={classes.place}>
            {place}
          </div>
          <div className={classes.personDetails}>
            <span className={classes.fullName}>{name}</span>
            <span className={classes.points}>{points}</span>
          </div>
        </li>
      ))}
    </ul>
  );
};
